import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { prop, map, pickAll, take, defaultTo, equals } from 'ramda';

import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import TileRow from './TileRow';
import { oneOf } from 'lib/conditions';

import { path } from 'routes/Documents/routes/Lifestyle';

import icon from '../assets/lifestyle.svg';

const opt = o => (o ? `lifestyle.opts.${o}` : null);

const View = ({ data, localeMessage }) => (
  <Grid fluid>
    {map(d => (
      <div key={d.documentId}>
        <TileRow title={localeMessage('lifestyle.sections.exercise')}>
          <p className="bold">{localeMessage(opt(prop('excerciseInterval', d)))}</p>
        </TileRow>
        <TileRow title={localeMessage('lifestyle.tile.smokingViewLabel')}>
          {oneOf('smoking', ['yes', 'smokedBefore'])(d) && (
            <p className="bold">
              {localeMessage('lifestyle.tile.smoking', map(defaultTo(0), pickAll(['smoking', 'cigarettesADay'], d)))}
            </p>
          )}
        </TileRow>
        <TileRow title={localeMessage('lifestyle.sections.alcohol')}>
          {prop('alcoholUse', d) && <p className="bold">{localeMessage(opt(prop('alcoholUse', d)))}</p>}
        </TileRow>
        <TileRow title={localeMessage('lifestyle.sections.otherSubstances')}>
          {equals(prop('usingOtherSubstances', d), 'yes') && (
            <p className="bold">{localeMessage(opt(prop('usingOtherSubstances', d)))}</p>
          )}
        </TileRow>
      </div>
    ))(take(1, data))}
  </Grid>
);

View.propTypes = {
  data: PropTypes.array,
  localeMessage: PropTypes.func.isRequired,
};

export default createSummaryTile(View, { module: 'msLifestyle', localeId: 'lifestyle.title', routeTo: path, icon });
